import { isObject } from './is-object'

export const fromPath = (target: any, path: string): string => {
  let current = target
  const paths = path.split('.')

  for (let i = 0; i < paths.length; i++) {
    if (!current[paths[i]]) return ''
    current = current[paths[i]]
  }
  return isObject(current) ? '' : (current as string)
}
